import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initPostHog } from "./lib/posthog";

// Boot PostHog analytics (no-op if VITE_POSTHOG_KEY is not set)
initPostHog();

// Sync <html lang> attribute with stored language preference
const storedLang = localStorage.getItem("guestly_lang");
if (storedLang) {
  document.documentElement.lang = storedLang;
}

createRoot(document.getElementById("root")!).render(<App />);
